/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface OrganizationsCancelInvitation$Params {

/**
 * The ID of the organization
 */
  organizationId: string;

/**
 * The ID of the invitation to cancel
 */
  invitationId: string;
}

export function organizationsCancelInvitation(http: HttpClient, rootUrl: string, params: OrganizationsCancelInvitation$Params, context?: HttpContext): Observable<StrictHttpResponse<{

/**
 * The status of the canceled invitation
 */
'status'?: string;
}>> {
  const rb = new RequestBuilder(rootUrl, organizationsCancelInvitation.PATH, 'delete');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.path('invitationId', params.invitationId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      
      /**
       * The status of the canceled invitation
       */
      'status'?: string;
      }>;
    })
  );
}

organizationsCancelInvitation.PATH = '/organizations/{organizationId}/users/invitations/{invitationId}';
